// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autocompleteContentStyles } from "@stoneage/Overrides/Widgets/Header/AutocompleteContent";
import { fontConfig } from "@stoneage/XDL/constants";
import { css } from "styled-components";

autocompleteContentStyles.headerText = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        margin-bottom: 12px;
    `,
};

autocompleteContentStyles.linksWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

autocompleteContentStyles.link = {
    color: "secondary",
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
    },
    css: css`
        align-self: baseline;
    `,
};
